import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import React, { FC } from 'react';

import styles from './styles.module.scss';

const PhiDisclaimerFooter: FC = (): JSX.Element => (
  <div className={styles.phiDisclaimerFooter}>
    <LockOutlinedIcon className={styles.icon} />
    <span>
      This page collects protected health information (PHI) and personally identifiable information (PII). This data
      is encrypted and handled in accordance with HIPAA and our notice of privacy practices.
    </span>
  </div>
);

export default PhiDisclaimerFooter;
